import { useAuth } from "../../context/AuthContext";
import ZakaznickyProfil from "./sections/ZakaznickyProfil";
import ProfilObsluhy from "./sections/ProfilObsluhy";
import "./ProfilePage.scss";

/**
 * `/profil` slúži obsluhe aj zákazníkovi a vyzerá pre oboch rovnako (záhlavie
 * `PageHero` + mriežka kariet), ale ukazuje im iné veci: zákazník má navyše
 * saldo (R40) a doručovacie adresy (R23), obsluha nemá ani jedno. Preto sa
 * nevetví vnútri jednej sekcie, ale vyberá sa celá.
 */
function ProfilePage() {
  const { userRole } = useAuth();

  return (
    <div className="profile">
      <main className="profile__content">
        {userRole === "CUSTOMER" ? <ZakaznickyProfil /> : <ProfilObsluhy />}
      </main>
    </div>
  );
}

export default ProfilePage;
